export const trimLeadingSlash = (urlPath: string): string => urlPath.replace(/^\//, '');
export const trimTrailingSlash = (urlPath: string): string => urlPath.replace(/\/$/, '');
export const trimLeadingAndTrailingSlash = (urlPath: string): string => trimTrailingSlash(trimLeadingSlash(urlPath));
